import BookCover from '@/components/sections/BookCover';
import EmailSubscription from '@/components/sections/EmailSubscription';
import UdemyCourse from '@/components/sections/UdemyCourse';
import WhereToBuy from '@/components/sections/WhereToBuy';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Chapters from '../components/sections/Chapters';
import Content from '../components/sections/Content';
import FAQ from '../components/sections/FAQ';
import Features from '../components/sections/Features';
import Hero from '../components/sections/Hero';
import KeyFeatures from '../components/sections/KeyFeatures';
import Reality from '../components/sections/Reality';
import WhatIsTesting from '../components/sections/WhatIsTesting';
import WhyJestAndTestingLibrary from '../components/sections/WhyJestAndTestingLibrary';
import { I18nProvider, useI18n } from '../i18n/I18nProvider';
import { AMAZON_URL, LEANPUB_URL, UDEMY_URL } from '../lib/constants';

const EnglishPage: React.FC = () => {
  return (
    <I18nProvider initialLocale='en'>
      <EnglishContent />
    </I18nProvider>
  );
};

const EnglishContent = () => {
  const { t } = useI18n();

  return (
    <>
      <Helmet>
        <title>{t.meta.title}</title>
        <meta name='description' content={t.meta.description} />
        <meta name='keywords' content='angular, testing, jest, testing library, unit testing, signals, guide' />
        <meta property='og:title' content={t.meta.title} />
        <meta property='og:description' content={t.meta.description} />
        <meta property='og:type' content='website' />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content={t.meta.title} />
        <meta name='twitter:description' content={t.meta.description} />
        <html lang='en' />
        <link rel='alternate' hrefLang='en' href='/en' />
        <link rel='alternate' hrefLang='es' href='/' />
        <link rel='canonical' href='/en' />
      </Helmet>

      <div className='min-h-screen flex flex-col'>
        <Header leanpubUrl={LEANPUB_URL} />
        <main className='flex-grow'>
          <Hero leanpubUrl={LEANPUB_URL} />
          <EmailSubscription />
          <BookCover />
          <WhereToBuy amazonUrl={AMAZON_URL} leanpubUrl={LEANPUB_URL} />
          <WhatIsTesting />
          <KeyFeatures />
          <WhyJestAndTestingLibrary />
          <Chapters />
          <Reality />
          <Features />
          {/* <Testimonials /> */}
          {/* <Videos /> */}
          <Content />
          <FAQ />
          <UdemyCourse udemyUrl={UDEMY_URL} />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default EnglishPage;
